import { number, object, string } from 'yup'

import { EC2_REGIONS_MAP, INSTANCE_TYPES_MAP } from '@/views/Admin/Transcoders/transcoders.table'

import { INPUT_TYPES } from './TranscoderForm.constants'

export const transcoderFormValidationSchema = object().shape({
  region: string().oneOf(Object.keys(EC2_REGIONS_MAP)).required('Region is required'),
  instanceType: string()
    .oneOf(Object.keys(INSTANCE_TYPES_MAP))
    .required('Instance Type is required'),
  inputType: string().oneOf(INPUT_TYPES).required('Input Type is required'),
  instanceCount: number()
    .required('Instance Count is required. Must be a number between 1 and 50')
    .min(1, 'Instance Count must be at least 1 instance')
    .max(50, 'Instance Count must not exceed 50 instances')
})
